import { render, staticRenderFns } from "./DiscountEdit.vue?vue&type=template&id=3c2abafa"
import script from "./DiscountEdit.vue?vue&type=script&lang=js"
export * from "./DiscountEdit.vue?vue&type=script&lang=js"
import style0 from "./DiscountEdit.vue?vue&type=style&index=0&id=3c2abafa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports